export const pathInspectorTables = {
  vAciEndpoint: 'ACI',
  vAciVrf: 'ACI VRF',
  vArp: 'ARP',
  vFabricPathRoutes: 'FabricPath Routes',
  vIgmpGroup: 'IGMP Group',
  vIgmpSnoopingGroup: 'IGMP Snooping Group',
  vIpSecTunnels: 'IPsec tunnels',
  vLispLocal: 'LISP',
  vLispRemote: 'LISP',
  vMac: 'MAC',
  vMplsForwarding: 'MPLS-forward',
  vMulticastRoute: 'Multicast Routes',
  vNeighborDiscovery: 'Neighbor Discovery',
  vRoute: 'Routes',
  vRouteIpv6: 'Routes IPv6',
  vSpbmBMac: 'SPBM B-MAC',
  vSpbmISid: 'SPBM Services',
  vVirtualServer: 'Virtual Servers',
};
